import { useResetQueryErrors } from '../../hooks/query';
import {
  useQueryStateContext,
  useVisualComponentsContext,
  useQueryHistoryStateContext,
} from '../../contexts';

export const UndoButton = () => {
  const { UndoQueryButton: VisualComponent } = useVisualComponentsContext();
  const { isReadOnly = false } = useQueryStateContext();
  const { undoQuery, undoStack } = useQueryHistoryStateContext();
  const resetQueryErrors = useResetQueryErrors();
  const handleUndo = () => {
    undoQuery();
    resetQueryErrors();
  };
  const isUndoStackEmpty = undoStack.length === 0;
  return <VisualComponent isDisabled={isReadOnly || isUndoStackEmpty} onClick={handleUndo} />;
};
